import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Ingest a token hand-off from the viewer (passed as #token=<jwt>)
const _hash = window.location.hash; // e.g. "#token=eyJ..."
if (_hash.startsWith('#token=')) {
  const _token = decodeURIComponent(_hash.slice('#token='.length));
  if (_token) {
    localStorage.setItem('aere_access_token', _token);
    // Decode JWT payload to populate aere_user (same shape authProvider expects)
    try {
      const _payload = JSON.parse(
        atob(_token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
      ) as { sub?: string; email?: string; role?: string };
      localStorage.setItem(
        'aere_user',
        JSON.stringify({ id: _payload.sub ?? '', email: _payload.email ?? '', role: _payload.role ?? '' })
      );
    } catch { /* malformed token — ignore */ }
    // Remove the hash so the token doesn't stay in the browser history
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
